import React, { useState, useEffect, Suspense } from 'react';
import { ConsentManagementPlatform } from '@guardian/consent-management-platform/dist/ConsentManagementPlatform';
import { init as initCCPA, shouldShow, setErrorHandler, checkWillShowUi as checkWillShowCCPAUi, } from '@guardian/consent-management-platform';
import { ccpaApplies } from '@root/src/web/lib/ccpaApplies';
import { addPrivacySettingsLink } from './CMPPrivacyLink';
// this is the wrong place to be doing this, but it's temporary
// until we remove the old react CMP component and go 100% sourcepoint
export const willShowNewCMP = async () => {
    const useCCPA = await ccpaApplies();
    if (useCCPA) {
        initCCPA({
            useCcpa: true,
        });
        addPrivacySettingsLink();
        return checkWillShowCCPAUi();
    }
    return false;
};
export const shouldShowOldCMP = async () => (await ccpaApplies()) ? false : shouldShow();
export const CMP = () => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        setShow(true);
        // setErrorHandler takes function to be called on errors in the CMP UI
        setErrorHandler((errMsg) => {
            const err = new Error(errMsg);
            window.guardian.modules.sentry.reportError(err, 'cmp');
        });
    }, []);
    return (React.createElement(React.Fragment, null, show && (React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
        React.createElement(ConsentManagementPlatform, { source: "dcr", onClose: () => setShow(false) })))));
};
